class AMHeaderDrawer extends HTMLElement {
  connectedCallback() {
    this.openBtn = this.querySelector('[data-am-drawer-open]');
    this.closeBtn = this.querySelector('[data-am-drawer-close]');
    this.panel = this.querySelector('[data-am-drawer-panel]');
    if (!this.openBtn || !this.closeBtn || !this.panel) return;

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleViewportChange = this.handleViewportChange.bind(this);
    // Keep in sync with the navigation breakpoint in am-header.liquid.
    this.desktopMedia = window.matchMedia('(min-width: 920px)');

    this.openBtn.addEventListener('click', this.open);
    this.closeBtn.addEventListener('click', this.close);
    this.desktopMedia.addEventListener('change', this.handleViewportChange);
  }

  disconnectedCallback() {
    if (this.panel && !this.panel.hidden) this.close({ restoreFocus: false });
    this.openBtn?.removeEventListener('click', this.open);
    this.closeBtn?.removeEventListener('click', this.close);
    this.desktopMedia?.removeEventListener('change', this.handleViewportChange);
    document.removeEventListener('keydown', this.handleKeydown);
  }

  open() {
    if (this.desktopMedia.matches || !this.panel.hidden) return;
    this.previousOverflow = document.body.style.overflow;
    this.panel.hidden = false;
    this.openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this.handleKeydown);
    const firstLink = this.panel.querySelector('a, button');
    if (firstLink) firstLink.focus();
  }

  close({ restoreFocus = true } = {}) {
    if (this.panel.hidden) return;
    this.panel.hidden = true;
    this.openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = this.previousOverflow;
    document.removeEventListener('keydown', this.handleKeydown);
    if (restoreFocus) this.openBtn.focus();
  }

  handleViewportChange() {
    if (!this.desktopMedia.matches || this.panel.hidden) return;
    const focusInDrawer = this.panel.contains(document.activeElement);
    this.close({ restoreFocus: false });
    if (focusInDrawer) this.querySelector('.am-header__logo')?.focus();
  }

  handleKeydown(event) {
    if (event.key === 'Escape') this.close();
  }
}

if (!customElements.get('am-header-drawer')) {
  customElements.define('am-header-drawer', AMHeaderDrawer);
}
